import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { clearAdminSession } from "../lib/adminAuth";

const NAV_ITEMS: { to: string; label: string }[] = [
  { to: "/admin", label: "Dashboard" },
  { to: "/admin/users", label: "Users" },
  { to: "/admin/listings", label: "Listings" },
  { to: "/admin/disputes", label: "Disputes" },
  { to: "/admin/tickets", label: "Support tickets" },
  { to: "/admin/coupons", label: "Coupons" },
  { to: "/admin/posts", label: "Blog posts" },
  { to: "/admin/account-transfers", label: "Account transfers" },
  { to: "/admin/domain-transfers", label: "Domain transfers" },
  { to: "/admin/flagged-messages", label: "Flagged chats" },
  { to: "/admin/audit-log", label: "Audit log" },
  { to: "/admin/maintenance", label: "Maintenance mode" },
];

/** Layout for the whole `/admin/*` tree — deliberately separate from `AppShell` (no public-site
 *  header/footer/wallet widget). A distinct look reinforces that this is a different system, not
 *  a role-gated corner of the buyer/seller app. */
export function AdminShell() {
  const navigate = useNavigate();

  function handleLogout() {
    clearAdminSession();
    navigate("/admin/login", { replace: true });
  }

  return (
    <div className="admin-shell">
      <header className="admin-shell__header">
        <div className="admin-shell__brand">MarketOnBase — Admin</div>
        <nav className="admin-shell__nav" aria-label="Admin">
          {NAV_ITEMS.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.to === "/admin"}>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <button type="button" className="btn btn-secondary btn-sm" onClick={handleLogout}>
          Sign out
        </button>
      </header>
      <main className="admin-shell__main">
        <Outlet />
      </main>
    </div>
  );
}
